import { render, staticRenderFns } from "./ScratchCardManual.vue?vue&type=template&id=959d98a2&scoped=true"
import script from "./ScratchCardManual.vue?vue&type=script&lang=js"
export * from "./ScratchCardManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959d98a2",
  null
  
)

export default component.exports